// extracted by mini-css-extract-plugin
module.exports = {"message":"BankingInfo_message_2VKXu","section":"BankingInfo_section_oiGCR","form":"BankingInfo_form_3eteH","row":"BankingInfo_row_2Pn-5","input":"BankingInfo_input_2RSeQ"};